import React, { useState, useEffect } from 'react';
import { Col, Row, Label } from 'reactstrap';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import Loading from '../../../components/modales/loadingModal';

//API Calls
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';
const editarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');
const envioCorreo = functionsHttpsCallable('correos_envioCorreoAPE');
const listaContratadores = functionsHttpsCallable('ape_listadoContratadores');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalAsignacionContratador = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(false);
    const [listadoReclutadores, setListadoReclutadores] = useState([]);

    useEffect(() => {
        async function getData() {
            await getListadoReclutadores()
        }
        getData()
    }, [])

    const getListadoReclutadores = async () => {
        setLoading(true)
        const listado = await listaContratadores({ cod_empr: userData.codigoEmpresa })
        setListadoReclutadores(listado.data.data)
        setLoading(false)
    }

    const handleAsignacion = async () => {
        const body = {
            cod_soli: props.solicitud,
            cod_empr: userData.codigoEmpresa,
            data: {
                cod_actu: user.id,
                cod_cont: user.id,
                cod_cont_mail: user.correo,
                cod_cont_name: user.nombre,
                cod_cont_carg: user.cargo,
            }
        }
        try {
            setLoading(true)
            await editarAPE(body)
            let correoData = {
                tipo: "asignacion",
                codigoAPE: props.solicitud,
                estado: 'CONTRATADOR',
                enviarA: [
                    user.correo 
                ]
            }
            await envioCorreo(correoData) 
            setLoading(false)
            props.toastSuccess('Solicitud asignada!')
            props.actualizarSolicitudes()
            props.toggle()
        }
        catch(error){
            setLoading(false)
            console.log(error)
            props.toastError('Hubo un error al asignar la solucitud')
        }
    }

    if (loading) { return <div className={"loading-area"}> <Loading /> </div> }
    else return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                title={`Asignar proceso de Contratación Solicitud ${props.solicitud ?? 'NA'}`}
                buttonTitle={'Asignar'}
                enableOk={true}
                onClick={() => handleAsignacion()}
            // buttonLoading={cancelando}
            >
                <Row>
                    <Col lg='6' md='6' xs="12">
                        <Label>Seleccione el contratador:</Label>
                        <Autocomplete
                            required
                            margin="dense"
                            options={listadoReclutadores.length > 0 ? listadoReclutadores : []}
                            key={`key_Select_Recl`}
                            id={`select_Recl`}
                            onChange={(event, newValue) => setUser(newValue)}
                            renderInput={(params) => (
                                <TextField {...params} label={'Select'} margin="normal" />
                            )}
                            getOptionLabel={(option) => option.nombre}
                            renderOption={(option) => (
                                <React.Fragment>
                                    {option.nombre}
                                </React.Fragment>
                            )}
                        />
                    </Col>
                </Row>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalAsignacionContratador);